import { CallAPI } from "../../apiManager/ApiCall";
import {
  activityAdminCountryPurchasePotentialURL,
  activityAdminFeatureUsageURL,
  activityAdminInAppPurchaseURL,
  activityAdminOverviewURL,
  activityAdminTimelineURL,
} from "../../apiManager/APIConfig";

const queryString = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && String(v) !== "") {
      q.append(k, String(v));
    }
  });
  const s = q.toString();
  return s ? `?${s}` : "";
};

export const GetActivityOverviewCall = async (params = {}) =>
  CallAPI({
    url: `${activityAdminOverviewURL}${queryString(params)}`,
    method: "GET",
  });

export const GetActivityInAppPurchaseCall = async (params = {}) =>
  CallAPI({
    url: `${activityAdminInAppPurchaseURL}${queryString(params)}`,
    method: "GET",
  });

export const GetActivityTimelineCall = async (params = {}) =>
  CallAPI({
    url: `${activityAdminTimelineURL}${queryString(params)}`,
    method: "GET",
  });

export const GetActivityFeatureUsageCall = async (params = {}) =>
  CallAPI({
    url: `${activityAdminFeatureUsageURL}${queryString(params)}`,
    method: "GET",
  });

export const GetActivityCountryPurchasePotentialCall = async (params = {}) =>
  CallAPI({
    url: `${activityAdminCountryPurchasePotentialURL}${queryString(params)}`,
    method: "GET",
  });

